import { get, getPaginated, patch, post, remove } from '@/api/base'
import vehicleChambersApi from '@/api/vehicles/chambers'

const vehiclesApi = {
  get: async vehicleUuid => {
    const response = await get({
      path: `vehicles/${vehicleUuid}`,
    })
    return response.success ? response.data.vehicle : null
  },
  getAll: async params => {
    const response = await get({
      path: 'vehicles',
      params,
    })
    return response.success
      ? {
          ...response,
          vehicles: response.data.vehicles,
          pagination: response.data.meta.pagination,
        }
      : response
  },
  getAllForCompany: async companyUuid => {
    const response = await get({
      path: 'vehicles',
      params: {
        company_uuid: companyUuid,
      },
    })
    return response.success ? response.data.vehicles : []
  },
  update: async (vehicleUuid, params) => {
    return await patch({
      path: `vehicles/${vehicleUuid}`,
      params,
    })
  },
  getVersions: async (vehicleUuid, params) => {
    const response = await get({ path: `versions/vehicles/${vehicleUuid}`, params })
    return response.success
      ? {
          versions: response.data.versions,
          pagination: response.data.meta.pagination,
        }
      : null
  },
  create: async params => {
    const response = await post({
      path: `vehicles`,
      params,
    })
    return response.success ? response.data.vehicle : null
  },
  delete: async vehicleUuid => {
    return await remove({ path: `vehicles/${vehicleUuid}` })
  },
  selectableVehicles: async companyUuid => {
    const { success, values } = await getPaginated({
      path: `vehicles/selectable_vehicles`,
      valuePath: 'vehicles',
      params: { company_uuid: companyUuid },
    })

    return success ? values : []
  },
  chambers: vehicleChambersApi,
}

export default vehiclesApi
